// TODO: move to beam
import { useState, useEffect } from 'react'
import { isFinite } from 'lodash'
import PropTypes from 'prop-types'
import moment from 'moment'
import MaskedTextField from '../../Common/MaskedTextField'
import { toHumanReadable } from 'beam/dist/utils/duration'

const displayDurationToMs = displayDuration => {
  return moment.duration(displayDuration).asMilliseconds()
}

const msToDisplayDuration = ms => {
  if (!isFinite(ms)) {
    return '00:00:00'
  }

  const duration = moment.duration(ms)
  return toHumanReadable(duration)
}

// Our handlers must change the input field state which is passed into the text field, as well as pass the changed value (in MS) up to the onChange function
const createDurationBlurHandler = (setInputValue, onChange) => e => {
  const value = e.target.value
  const msValue = displayDurationToMs(value)
  setInputValue(msToDisplayDuration(msValue))
  onChange(msValue)
}

const DurationTextField = ({ onChange, value, ...others }) => {
  // Manages the field input state
  const [inputValue, setInputValue] = useState('')
  // When the passed value changes, set the input field
  useEffect(() => setInputValue(msToDisplayDuration(value)), [value])
  // When the input blurs call onChange with ms instead of input value
  const onInputBlur = createDurationBlurHandler(setInputValue, onChange)

  return (
    <div onBlur={onInputBlur}>
      <MaskedTextField
        {...others}
        value={inputValue}
        mask={[/\d/, /\d/, ':', /\d/, /\d/, ':', /\d/, /\d/]}
        guide={false}
        showMask={false}
      />
    </div>
  )
}

DurationTextField.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

export default DurationTextField
